import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { makeStyles } from '@mui/styles';
import { FontVariantToken } from '@uipath/apollo-core';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
    summaryBox: {
        border: `1px solid ${theme.palette.semantic.colorBorderDeEmp}`,
        borderRadius: '8px',
        padding: '16px 24px',
        backgroundColor: theme.palette.semantic.colorBackgroundSecondary,
    },
}));

// ts-unused-exports:disable-next-line
export interface MigrationScheduleSummaryProps {
    selectedDates: string[];
}

export const MigrationScheduleSummary: React.FC<MigrationScheduleSummaryProps> = ({ selectedDates }) => {
    const classes = useStyles();
    const {
        formatMessage: translate, locale,
    } = useIntl();

    const {
        firstDate, lastDate,
    } = useMemo(() => {
        if (selectedDates.length === 0) {
            return {
                firstDate: '',
                lastDate: '',
            };
        }

        const sorted = [ ...selectedDates ].sort((a, b) => a.localeCompare(b));
        const formatOpt: Intl.DateTimeFormatOptions = {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
            year: 'numeric',
        };

        return {
            firstDate: new Date(sorted[0] + 'T00:00:00').toLocaleDateString(locale, formatOpt),
            lastDate: new Date(sorted[sorted.length - 1] + 'T00:00:00').toLocaleDateString(locale, formatOpt),
        };
    }, [ selectedDates, locale ]);

    if (selectedDates.length === 0) {
        return null;
    }

    return (
        <div className={classes.summaryBox}>
            <UiStack
                direction="column"
                gap={SpacingToken.Micro}>
                <UiStack
                    align="center"
                    gap={SpacingToken.XS}>
                    <CheckCircleOutlineIcon sx={{
                        fontSize: 20,
                        color: 'success.main',
                    }} />
                    <UiText variant={FontVariantToken.fontSizeMBold}>
                        {translate({ id: 'CLIENT_MIGRATION_CANDIDATE_WINDOWS_SELECTED' }, { count: selectedDates.length })}
                    </UiText>
                </UiStack>
                <UiText variant={FontVariantToken.fontSizeS}>
                    {translate({ id: 'CLIENT_MIGRATION_FIRST_LAST_ATTEMPT' }, {
                        first: firstDate,
                        last: lastDate,
                    })}
                </UiText>
            </UiStack>
        </div>
    );
};
